// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"60":"685644e7","190":"daee1744","220":"df024041","442":"c038c9f0","462":"62ac5a76","557":"aaf8323f","574":"fa082a53","596":"1e822ccc","618":"fa82d710","648":"886e17a5","782":"7c98be61","874":"6c3e4e1b"}[chunkId] + ".chunk.css";
};